import { REQUEST_ATTEMPT_DEFAULT as Ae } from "../common/constants.js";
import { STORAGE_KEYS as i } from "../managers/storage-manager.js";
const T = {
  Os: { Na: "d", Ks: "cc", Si: "ff", Lr: "t" },
  rm: (e) => {
    if (e) return e.v(i.k.EE);
  },
  sm: (e) => {
    if (e) return e.v(i.k.lE);
  },
  nm: (e, t) => {
    e && e.D(i.k.EE, t);
  },
  um: (e, t) => {
    e && e.D(i.k.lE, t);
  },
  La: (e, t) => {
    if (!e || !t) return -1;
    const r = T.rm(e);
    if (null == r) return -1;
    const s = r[t];
    return null == s || isNaN(s) ? -1 : s;
  },
  Wa: (e, t) => {
    let r = Ae;
    if (!e || !t) return r;
    const s = T.sm(e);
    return null == s ? r : ((r = s[t]), null == r || isNaN(r) ? Ae : r);
  },
  Ws: (e, t, r) => {
    if (!e || !t) return;
    let s = T.rm(e);
    null == s && (s = {}), (s[t] = r), T.nm(e, s);
  },
  si: (e, t, r) => {
    if (!e || !t) return;
    let s = T.sm(e);
    null == s && (s = {}), (s[t] = r), T.um(e, s);
  },
  hi: (e, t) => {
    if (!e || !t) return;
    const r = T.Wa(e, t);
    T.si(e, t, r + 1);
  },
};
export default T;
